import { cn } from '@/lib/utils'
import Link from 'next/link'
import React from 'react'
import { Button } from './button'

const PrimaryButton = ({ btnName, href, className, target = '_self' }: { btnName: string, href?: string, icon?: boolean, className?: string, target?: string }) => {
    return (
        <>
            {href ? <Link target={target} href={href} className={cn('primary-btn group/primary-btn h-fit w-fit shrink-0 font-lexend', className)}>
                <span className='h-full w-full bg-custom-primary absolute top-0 left-0 group-hover/primary-btn:scale-y-[0.7] group-hover/primary-btn:scale-x-90 transition rounded-sm group-hover:rounded' />
                <div className='flex items-center gap-2 text-nowrap relative'>
                    {btnName}
                </div>
            </Link> : <Button disabled className={cn('primary-btn bg-custom-primary/50 text- cursor-not-allowed font-lexend', className)}>
                {btnName}
            </Button>}
        </>
    )
}

export default PrimaryButton